import { render, staticRenderFns } from "./ChartHeading.vue?vue&type=template&id=3fa1a3e2&"
import script from "./ChartHeading.vue?vue&type=script&lang=js&"
export * from "./ChartHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports